import State from '../core/State';
import TiktokAdAccount from '../entity/TiktokAdAccount';
import initialState from '../initialState';

export const setTiktokAdAccounts = (tiktokAdAccounts: ReadonlyArray<TiktokAdAccount>) => (state: State): State => ({
  ...state,
  tiktokAdAccounts,
});

export const setTiktokUploadedCreative = (tiktokUploadedCreative: boolean) => (state: State): State => ({
  ...state,
  tiktokUploadedCreative,
});

export const setTiktokAdAccountTokenId = (tokenId: string) => (state: State): State => ({
  ...state,
  integratedTiktokAdAccounts: {
    ...state.integratedTiktokAdAccounts,
    tokenId,
  },
});

export const startIntegratedTiktokAdAccounts = () => (state: State): State => ({
  ...state,
  integratedTiktokAdAccounts: {
    ...state.integratedTiktokAdAccounts,
    fetching: state.integratedTiktokAdAccounts.fetching + 1,
  },
});

export const setIntegratedTiktokAdAccounts = (integratedTiktokAdAccounts: ReadonlyArray<TiktokAdAccount>) => (
  state: State,
): State => ({
  ...state,
  integratedTiktokAdAccounts: {
    ...state.integratedTiktokAdAccounts,
    adAccounts: integratedTiktokAdAccounts,
    fetching: state.integratedTiktokAdAccounts.fetching - 1,
  },
});

export const finishIntegratedTiktokCommunication = () => (state: State): State => ({
  ...state,
  integratedTiktokAdAccounts: {
    ...state.integratedTiktokAdAccounts,
    fetching: state.integratedTiktokAdAccounts.fetching - 1,
  },
});

export const disposeTiktokAdAccounts = () => (state: State): State => ({
  ...state,
  tiktokAdAccounts: initialState.tiktokAdAccounts,
});
